import React, { useState, useCallback } from "react";
import Dialog from "@material-ui/core/Dialog";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useInput } from "../../../utils/hooks";
import {
  ageCul,
  genCul,
  que1Cul,
  que2Cul,
  que3Cul,
  que4Cul,
  bmi,
} from "../../../utils/calculate";
import LungInputForm from "./LungInputForm";
import LungResultForm from "./LungResultForm";
import LungReportForm from "./LungReportForm";

const regexp = /^[0-9]*$/;

const DiaLogFilter = ({
  result,
  sex,
  que1,
  que2,
  que3,
  que4,
  cm,
  age,
  kg,
  year,
  gap,
  setSex,
  setQue1,
  setQue2,
  setQue3,
  setQue4,
  handleClose,
  handleResult,
  total,
  onReportGo,
}) => {
  switch (result) {
    case 1:
      return (
        <LungInputForm
          sex={sex}
          que1={que1}
          que2={que2}
          que3={que3}
          que4={que4}
          cm={cm}
          age={age}
          kg={kg}
          year={year}
          gap={gap}
          setSex={setSex}
          setQue1={setQue1}
          setQue2={setQue2}
          setQue3={setQue3}
          setQue4={setQue4}
          handleClose={handleClose}
          handleResult={handleResult}
        />
      );
    case 2:
      return (
        <LungResultForm
          total={total}
          age={age}
          handleClose={handleClose}
          onReportGo={onReportGo}
        />
      );
    case 3:
      return (
        <LungReportForm
          total={total}
          age={age}
          handleClose={handleClose}
          sex={sex}
          que1={que1}
          que2={que2}
          que3={que3}
          que4={que4}
          cm={cm}
          kg={kg}
          year={year}
          gap={gap}
          setSex={setSex}
          setQue1={setQue1}
          setQue2={setQue2}
          setQue3={setQue3}
          setQue4={setQue4}
        />
      );

    default:
      return (
        <LungInputForm
          sex={sex}
          que1={que1}
          que2={que2}
          que3={que3}
          que4={que4}
          cm={cm}
          age={age}
          kg={kg}
          year={year}
          gap={gap}
          setSex={setSex}
          setQue1={setQue1}
          setQue2={setQue2}
          setQue3={setQue3}
          setQue4={setQue4}
          handleClose={handleClose}
          handleResult={handleResult}
        />
      );
  }
};

const LungForm = ({ onFormClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [sex, setSex] = useState(true);
  const [que1, setQue1] = useState(true);
  const [que2, setQue2] = useState(true);
  const [que3, setQue3] = useState(true);
  const [que4, setQue4] = useState(false);
  const [total, setTotal] = useState(0);
  const [result, setResult] = React.useState(1);
  const val = useCallback((data) => regexp.test(data) && data < 300, []);
  const val2 = useCallback((data) => data < 10, []);
  const cm = useInput(170, val);
  const age = useInput(40, val);
  const kg = useInput(70, val);
  const year = useInput(0, val);
  const gap = useInput(0, val2);

  const handleClose = () => {
    onFormClose();
  };

  const handleResult = () => {
    setTotal(
      ageCul(age) +
        genCul(sex) +
        que1Cul(que1) +
        que2Cul(que2) +
        que3Cul(que3) +
        que4Cul(que4, year.value, gap.value) +
        bmi(kg.value, cm.value)
    );
    setResult(2);
  };

  const handleReportGo = () => {
    setResult(3);
  };
  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth={true}
      maxWidth={"md"}
      open={true}
      aria-labelledby="responsive-dialog-title"
    >
      <DiaLogFilter
        result={result}
        sex={sex}
        que1={que1}
        que2={que2}
        que3={que3}
        que4={que4}
        cm={cm}
        age={age}
        kg={kg}
        year={year}
        gap={gap}
        setSex={setSex}
        setQue1={setQue1}
        setQue2={setQue2}
        setQue3={setQue3}
        setQue4={setQue4}
        handleClose={handleClose}
        handleResult={handleResult}
        total={total}
        onReportGo={handleReportGo}
        // age={age}
        // handleClose={handleClose}
      />
      {/* {if(result ===0){}else if(result===1){}}
      {result===0 ? (
        <LungInputForm
          
        />
      ) : (
        <LungResultForm  />
      )} */}
    </Dialog>
  );
};

export default LungForm;
